import createIcon from '../../createIcon';

/**
 * @component @name InsertChartOutlined
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxN0g3VjEwSDlWMTdaTTEzIDE3SDExVjdIMTNWMTdaTTE3IDE3SDE1VjEzSDE3VjE3Wk0xOS41IDE5LjFINC41VjVIMTkuNVYxOS4xWk0xOS41IDNINC41QzMuNCAzIDIuNSAzLjkgMi41IDVWMTlDMi41IDIwLjEgMy40IDIxIDQuNSAyMUgxOS41QzIwLjYgMjEgMjEuNSAyMC4xIDIxLjUgMTlWNUMyMS41IDMuOSAyMC42IDMgMTkuNSAzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const InsertChartOutlined = createIcon('InsertChartOutlined', [
  [
    'path',
    {
      d: 'M9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17ZM19.5 19.1H4.5V5H19.5V19.1ZM19.5 3H4.5C3.4 3 2.5 3.9 2.5 5V19C2.5 20.1 3.4 21 4.5 21H19.5C20.6 21 21.5 20.1 21.5 19V5C21.5 3.9 20.6 3 19.5 3Z',
      key: 'p0i5r',
    },
  ],
]);

export default InsertChartOutlined;
